import { render, staticRenderFns } from "./SamplingInformation.vue?vue&type=template&id=8d0e2642&scoped=true"
import script from "./SamplingInformation.vue?vue&type=script&lang=js"
export * from "./SamplingInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0e2642",
  null
  
)

export default component.exports